import { render, staticRenderFns } from "./CargoColegiadoForm.vue?vue&type=template&id=7e877f85&scoped=true&"
import script from "./CargoColegiadoForm.vue?vue&type=script&lang=js&"
export * from "./CargoColegiadoForm.vue?vue&type=script&lang=js&"
import style0 from "./CargoColegiadoForm.vue?vue&type=style&index=0&id=7e877f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e877f85",
  null
  
)

export default component.exports